import {Component, Input} from '@angular/core';

@Component({
    selector: 'dcp-generic-configurator-error',
    templateUrl: './generic-configurator-error.component.html',
    styleUrls: ['./generic-configurator-error.component.scss'],
    standalone: false
})
export class GenericConfiguratorErrorComponent {
  @Input() imgPath: string;
  @Input() headline: string = '';
  @Input() titleDisplay: boolean = false;
}
